import axios from "axios";
import { getPlatformToken } from "@/lib/musicApi";

const memo = new Map();
let scope = "";

// One GET per URL per page (path + signed-in identity); every caller shares the result.
export const pageGet = (url) => {
  const now = `${window.location.pathname}|${getPlatformToken() || ""}`;
  if (now !== scope) { memo.clear(); scope = now; }
  if (!memo.has(url)) memo.set(url, axios.get(url).then((r) => r.data).catch(() => null));
  return memo.get(url);
};
